'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Flexbox helper classes enable you to quickly layout items in relation to each other.
 */
var FlexContainer = function FlexContainer(_ref) {
  var vertical = _ref.vertical,
    verticalCenter = _ref.verticalCenter,
    horizontalCenter = _ref.horizontalCenter,
    center = _ref.center,
    justify = _ref.justify,
    justifyAround = _ref.justifyAround,
    spaced = _ref.spaced,
    spacedWide = _ref.spacedWide,
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    children = _ref.children;
  var flexContainerClassNames = (0, _classnames2.default)('o-flex', {
    'o-flex--vertical': vertical,
    'o-flex--vertical-center': verticalCenter,
    'o-flex--horizontal-center': horizontalCenter,
    'o-flex--center': center,
    'o-flex--justify-between': justify,
    'o-flex--justify-around': justifyAround,
    'o-flex--spaced': spaced,
    'o-flex--spaced-wide': spacedWide,
    'u-maximize-width': maxWidth,
    'u-maximize-height': maxHeight
  });
  return _react2.default.createElement('div', {
    className: flexContainerClassNames
  }, children);
};
FlexContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Align the elements vertically */
  vertical: _propTypes2.default.bool,
  /** Align the elements vertically centered */
  verticalCenter: _propTypes2.default.bool,
  /** Align the elements horizontally centered */
  horizontalCenter: _propTypes2.default.bool,
  /** Center the elements */
  center: _propTypes2.default.bool,
  /** Use a dynamic spacing between elements */
  justify: _propTypes2.default.bool,
  /** Justify all elements around*/
  justifyAround: _propTypes2.default.bool,
  /** Use a fixed spacing between elements */
  spaced: _propTypes2.default.bool,
  /** Use a wide fixed spacing between elements */
  spacedWide: _propTypes2.default.bool,
  /** Set the container to use full width */
  maxWidth: _propTypes2.default.bool,
  /** Set the container to user full height */
  maxHeight: _propTypes2.default.bool,
  /** Children of the container */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = FlexContainer;